module.exports = __webpack_public_path__ + "static/media/SF-12-A.5c2c3f68.mp3";